export function getOppositeColor(hex) {
  // Remove the hash at the start if it's there
  hex = hex.replace(/^#/, "");

  // Parse the r, g, b values
  let r = parseInt(hex.substring(0, 2), 16);
  let g = parseInt(hex.substring(2, 4), 16);
  let b = parseInt(hex.substring(4, 6), 16);

  // Invert each component
  r = (255 - r).toString(16).padStart(2, "0");
  g = (255 - g).toString(16).padStart(2, "0");
  b = (255 - b).toString(16).padStart(2, "0");

  // Recombine and return the opposite color
  return `#${r}${g}${b}`;
}
